// The card pick still on its way to the server.
//
// The gift room reopens the package when her one deeper card is down
// (closeDeeperPicker → care-package/open/), and that reopen moves this
// session's conversation onto the sender's reading. The picker fires the
// reopen and the pick (reading/card-selected/) in the same instant, so when
// the reopen reached the server first her pick was refused: 403 "That
// reading is not yours", and her card was never read (seen on the iphone
// project, 2026-10-19). Anything that must follow a pick waits on settled().
export function pickTracker () {
  let last = Promise.resolve()
  return {
    /** Remember a pick's request; hands the same promise back. */
    track (pick) {
      last = Promise.resolve(pick).catch(() => {})
      return pick
    },
    /** Resolves once the last pick has been answered (or failed). The
     * picker emits its "all cards down" trigger before the pick itself, in
     * the same tick: one microtask first lets that pick be tracked. */
    async settled () {
      await Promise.resolve()
      await last
    },
  }
}
